"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactLocationTabUI = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactLocationTabUI = class ContactLocationTabUI extends vue_property_decorator_1.Vue {
};
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: true }),
    __metadata("design:type", String)
], ContactLocationTabUI.prototype, "location", void 0);
ContactLocationTabUI = __decorate([
    vue_property_decorator_1.Component({
        name: 'ContactLocationTabUI',
        components: {
            BootstrapImage: front_1.BootstrapImage
        },
        template: `
    <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="contact__location">
            <iframe :src="location" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </section>
  `
    })
], ContactLocationTabUI);
exports.ContactLocationTabUI = ContactLocationTabUI;
//# sourceMappingURL=ContactLocation.js.map